import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const ConatinerHookloaderMappingApi = async (StartDate, endDate,VehicleNumber) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllContainerHookloaderMappingTransaction?startDate=${StartDate}&endDate=${endDate}&VehicleNumber=${VehicleNumber?VehicleNumber:""}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};